// @generated by protoc-gen-es v2.6.3 with parameter "keep_empty_files=true,target=js+dts"
// @generated from file proto/model/feature/hotel/hotel_types.proto (package carmen, syntax proto3)
/* eslint-disable */

import { enumDesc, fileDesc, tsEnum } from "@bufbuild/protobuf/codegenv2";

/**
 * Describes the file proto/model/feature/hotel/hotel_types.proto.
 */
export const file_proto_model_feature_hotel_hotel_types = /*@__PURE__*/
  fileDesc("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");

/**
 * Describes the enum carmen.HotelType.
 */
export const HotelTypeSchema = /*@__PURE__*/
  enumDesc(file_proto_model_feature_hotel_hotel_types, 0);

/**
 * Basic hotel types
 *
 * @generated from enum carmen.HotelType
 */
export const HotelType = /*@__PURE__*/
  tsEnum(HotelTypeSchema);

/**
 * Describes the enum carmen.BedType.
 */
export const BedTypeSchema = /*@__PURE__*/
  enumDesc(file_proto_model_feature_hotel_hotel_types, 1);

/**
 * Bed types for room configurations
 *
 * @generated from enum carmen.BedType
 */
export const BedType = /*@__PURE__*/
  tsEnum(BedTypeSchema);

/**
 * Describes the enum carmen.HotelRoomType.
 */
export const HotelRoomTypeSchema = /*@__PURE__*/
  enumDesc(file_proto_model_feature_hotel_hotel_types, 2);

/**
 * Hotel room type classification
 *
 * @generated from enum carmen.HotelRoomType
 */
export const HotelRoomType = /*@__PURE__*/
  tsEnum(HotelRoomTypeSchema);

/**
 * Describes the enum carmen.RoomAttributes.
 */
export const RoomAttributesSchema = /*@__PURE__*/
  enumDesc(file_proto_model_feature_hotel_hotel_types, 3);

/**
 * Room attributes and characteristics
 *
 * @generated from enum carmen.RoomAttributes
 */
export const RoomAttributes = /*@__PURE__*/
  tsEnum(RoomAttributesSchema);

/**
 * Describes the enum carmen.RoomAmenity.
 */
export const RoomAmenitySchema = /*@__PURE__*/
  enumDesc(file_proto_model_feature_hotel_hotel_types, 4);

/**
 * Room-specific amenities
 *
 * @generated from enum carmen.RoomAmenity
 */
export const RoomAmenity = /*@__PURE__*/
  tsEnum(RoomAmenitySchema);

